import React, { useCallback } from 'react';
import { useFieldArray } from 'react-final-form-arrays';

import {
  QualifiedEventsInitialFormValues,
  TargetingAttributesFormValues,
} from '@occc-app/routes/Audience/types';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';
import { qualifiedEventsInitialFormValues } from './constants';
import { QualifiedEventsFormArrayItem } from './QualifiedEventsFormArrayItem';

import { AddAnotherItem } from '../AddAnotherItem';
import { FormArrayItemSection } from '../FormArrayItemSection';

export type QualifiedEventsFormContentProps = {
  name: keyof TargetingAttributesFormValues;
};

export const QualifiedEventsFormContent = ({ name }: QualifiedEventsFormContentProps) => {
  const { fields } = useFieldArray<QualifiedEventsInitialFormValues>(name, {
    subscription: {
      length: true,
    },
  });

  const handleAddItem = useCallback(
    () =>
      fields.push({
        ...qualifiedEventsInitialFormValues,
      }),
    [fields],
  );
  const handleRemoveItem = useCallback((index: number) => fields.remove(index), [fields]);

  const { isEditable } = useCanEditFormFieldsContext();
  const isDeleteIconShown = isEditable && Boolean(fields.length && fields.length > 1);

  return (
    <>
      {fields.map((fieldName, index) => {
        return (
          <React.Fragment key={fieldName}>
            <FormArrayItemSection
              index={index}
              title={`Event ${index + 1}`}
              isDeleteIconShown={isDeleteIconShown}
              onDeleteClick={handleRemoveItem}
            />

            <QualifiedEventsFormArrayItem key={fieldName} fieldNamePrefix={fieldName} />
          </React.Fragment>
        );
      })}

      <AddAnotherItem title='Add Another Event' onClick={handleAddItem} />
    </>
  );
};
